<template>
  <yams-template>
    <template #header>
      <div class="mr-5">
        <h4 class="text-primary font-weight-bold">Factures ({{ courses.length }})</h4>
      </div>
    </template>

    <template #content>
      <div class="container">
        <form class="form-inline mb-4" @submit.prevent="changePeriod()">
        <input class="form-control form-control-sm" type="month" id="start" name="start" min="2018-03"
          v-model="form.period" />
        <button type="submit" class="ml-2 btn btn-sm btn-primary">
          <i class="fa-solid fa-magnifying-glass"></i> Charger
        </button>
      </form>
      <ProgressBar v-if="isLoading === true" mode="indeterminate" style="height: 6px; margin-bottom: 10px;"></ProgressBar>
      <p v-if="isEmpty == true" class="text-center"> Vous n'avez pas de facture disponible ce mois</p>
      <div class="card mb-3 shadow-2 " v-for="course in courses" :key="course.id" @click="exportPDF(course)">
      <div class=" card-body" >
        <div class="row">
        <div class="col-md-2" >
          <lottie-player mode="normal" style="width: 100%; max-width: 70px;" src="/json/truck_yams.json"></lottie-player>
        </div>
        <div class="col-md-2" >
          <p class="text-secondary">Date</p>
          <strong>{{ formatDate(course.date_dechargement) }}</strong>
        </div>
        <div class="col-md-2" >
          <p class="text-secondary">Reference</p>
          <strong>FAC{{ course.id }}</strong>
        </div>
        <div class="col-md-2" >
          <p class="text-secondary">Course</p>
          <strong>{{ course.code }}</strong>
        </div>
        <div class="col-md-2" >
          <p class="text-secondary">Montant</p>
          <strong>{{ formatPriceWithDevise(course.montant) }}</strong>
        </div>
        <div class="col-md-2" >
          <p class="text-secondary">Statut</p>
          <strong v-if="course.statut == 'En attente'" class="p-2 rounded-pill badge badge-danger">{{ course.statut }}</strong>
          <strong v-else-if="course.statut == 'Payé'" class="p-2 rounded-pill badge badge-success">{{ course.statut }}</strong>
          <strong v-else class="p-2 rounded-pill badge badge-warning">{{ course.statut }}</strong>
        </div>
      </div>
      </div>
    </div>
    </div>
    </template>
  </yams-template>

  <div hidden>
    <div id="facture" class="container-fluid">
      <Entete />
      <h3 class="my-3">Facture </h3>
      <div class="row d-flex justify-content-between mb-4">
        <div class="col-6">
          <strong> N° FAC{{ course_selected.id }}</strong><br />
          <strong> Date: </strong>{{ formatDate(course_selected.date_dechargement) }} <br />
        </div>
        <div class="col-6">
          <p>
            <strong> Nom : </strong> <span v-if="course_selected.client && course_selected.client.nom">{{ (course_selected.client.nom) }}</span> <br />
            <strong> Tel: </strong> <span v-if="course_selected.client && course_selected.client.nom">{{ course_selected.client.telephones }}</span> <br />
            <strong> Email: </strong> <span v-if="course_selected.client && course_selected.client.nom">{{ course_selected.client.email }}</span> <br />
            <strong> Adresse: </strong> <span v-if="course_selected.client && course_selected.client.nom">{{ course_selected.client.adresse }}</span> <br />
            <strong> BP: </strong> <span v-if="course_selected.client && course_selected.client.nom">{{ course_selected.client.bp }}</span><br />
          </p>
        </div>
      </div>

      <table class="table mb-3">
        <thead class="thead-light">
          <tr style="line-height: 1px;">
            <th scope="col">Description</th>
            <th scope="col">Quantité</th>
            <th scope="col">PU</th>
            <th scope="col">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Course {{ course_selected.code + ' ' + course_selected.type_course }} {{
              course_selected.adresse_chargement + ' ('+formatDate(course_selected.date_chargement)+') - '+course_selected.adresse_dechargement+' ('+formatDate(course_selected.date_dechargement)+')' }}{{ course_selected.description }}</td>
            <td>{{ qte }}</td>
            <td>{{ formatPrice(course_selected.montant) }}</td>
            <td>{{ formatPrice(course_selected.montant) }}</td>
          </tr>
        </tbody>
      </table>

      <div class="ml-auto col-6">
        <table class="table mb-3" style="line-height: 1px;">
          <tbody>
            <tr>
              <td colspan="2"></td>
              <td>Total TTC</td>
              <td> {{ formatPriceWithDevise(course_selected.montant) }} </td>
            </tr>


          </tbody>
        </table>
      </div>

      <div class="ml-auto col-5">
        <h6>La direction</h6>
        <img src="@/assets/yams-cachet.png" class="my-5">
      </div>


    </div>
  </div>

</template>

<script>
import { defineComponent } from 'vue';
import moment from 'moment'
import Entete from '@/layouts/ExportHead.vue';
import html2pdf from "html2pdf.js";

export default defineComponent({
  components: { Entete },

  name: 'IndexFacture',
  data() {
    return {
      lines: 0,
      isLoading: true,
      isEmpty: false,
      url: '/api/courses',
      facturesUrl: '/api/courses?req_period=' + moment().format('YYYY-MM'),
      courses: [],
      course_selected: [],
      form: {
        period: moment().format('YYYY-MM'),
      }
    };
  },
  mounted() {
    this.getFactures()
  },
  methods: {
    getFactures() {
      this.isLoading = true
      this.axios.get(this.facturesUrl).then((response) => {
        this.courses = response.data.data
        if (response.data.data.length < 1) {
                    this.isEmpty = true
                }
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
        this.$toast.add({
          severity: 'error',
          summary: 'Probleme de connexion',
          detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
          life: 5000
        });
      })
    },
    changePeriod() {
      this.isEmpty = false
      this.facturesUrl = this.url + '?req_period=' + this.form.period
      this.getFactures()
    },
    formatDate(val) {
      if (val) return moment(String(val)).format('DD/MM/YYYY')
    },
    formatPriceWithDevise(val) {
      if (val) return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'XAF' }).format(val)
    },
    formatPrice(val) {
      if (val) return new Intl.NumberFormat('de-DE').format(val)
    },
    exportPDF(line) {
      this.course_selected = line
      this.isLoading = true
      html2pdf().set({
        pagebreak: { mode: 'avoid-all' },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
        margin: [0.3, 0.3],
        filename: "facture " + line.id,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 }
      }).from(document.getElementById("facture"))
        .toPdf()
        .get('pdf')
        .then(function (pdf) {
          var totalPages = pdf.internal.getNumberOfPages();

          pdf.setFontSize(7.60);
          pdf.setTextColor(150);

          for (var i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.text(' S.A.R.L au capital de 1.000.000 F CFA | Oloumi - BP: 1073 Libreville | Tel: +241 (0) 1 74 78 91 - 062 13 71 78 ' + "\n" + 'RCCM: GA-LBV-01-2020-B13-00255 / NIF: 054889 C  | Email: infos@yamslogistics.com / Site web: yamslogistics.com', pdf.internal.pageSize.getWidth() - 0.25, pdf.internal.pageSize.getHeight() - 0.50, { align: 'right' });
          }
        })
        .save();
    }
  },

})
</script>

<style scoped>
.card {
  cursor: pointer;
}
</style>